import { render, staticRenderFns } from "./TheDefaultHeader.vue?vue&type=template&id=0ae03552&scoped=true"
import script from "./TheDefaultHeader.vue?vue&type=script&lang=js"
export * from "./TheDefaultHeader.vue?vue&type=script&lang=js"
import style0 from "./TheDefaultHeader.vue?vue&type=style&index=0&id=0ae03552&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae03552",
  null
  
)

export default component.exports